export default __webpack_public_path__ + "static/es-1a25a96e26fcca676c08fb109bcec333.svg";